import React, { useEffect, useState } from "react";
import widgetsService from "../../services/widgetsService";
import ImportantDatesRail from "../ImportantDatesRail";
import LeaderboardWidget from "./LeaderboardWidget";
import StreaksWidget from "./StreaksWidget";

// Matches the rail cutover in index.css. Above it widgets sit in the grid's
// third track; below it they stack above the feed and start collapsed.
export const RAIL_CUTOFF = 1360;

const WIDGET_COMPONENTS = {
  important_dates: ImportantDatesRail,
  leaderboard: LeaderboardWidget,
  streaks: StreaksWidget,
};

/**
 * Renders the org's enabled widgets, in the admin-configured order.
 *
 * Order and enablement are org-level, so every member of an org sees the same
 * rail. Widgets that fail to load render nothing rather than breaking the feed.
 */
export default function WidgetRail({ forceCompact = null }) {
  const [widgets, setWidgets] = useState([]);
  const [compact, setCompact] = useState(
    typeof window !== "undefined" ? window.innerWidth < RAIL_CUTOFF : false
  );

  useEffect(() => {
    let cancelled = false;
    widgetsService
      .getWidgets()
      .then((data) => {
        if (!cancelled) setWidgets(Array.isArray(data) ? data : []);
      })
      .catch(() => {
        if (!cancelled) setWidgets([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    const onResize = () => setCompact(window.innerWidth < RAIL_CUTOFF);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // The flyout gives widgets a full-height panel of their own, so nothing
  // there needs to shrink to make room for a feed.
  const isCompact = forceCompact === null ? compact : forceCompact;

  if (!widgets.length) return null;

  return (
    <div className="space-y-3">
      {widgets.map((widget) => {
        const Component = WIDGET_COMPONENTS[widget.key];
        if (!Component) return null;
        return (
          <div key={widget.key} id={`widget-${widget.key}`}>
            <Component config={widget.config || {}} compact={isCompact} />
          </div>
        );
      })}
    </div>
  );
}
